import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function VerumPkgReducer(state = initialState.verumpkg, action: any) {
  switch (action.type) {

    case types.SAVE_VERUMPKG_SUCCESS:
      return action.verumpkg;

    default:
      return state;
  }
}
